async function loadDrawerDesign() {
    function loadProductCards() {
        const listElements = document.querySelectorAll('.menu-drawer__menu li[data-product]')
        
        listElements.forEach(async (li) => {
            const productURL = li.getAttribute('data-product');
            const isBestSeller = li.getAttribute('data-bestseller');
            const isNew = li.getAttribute('data-new');

            const response = await fetch(`${productURL}.json`);
            const data = await response.json();
            const { title, image: { src: media = data.product.image.src }, variants } = data.product;

            const tags = data.product.tags.split(',');
            let customTags = tags.filter(tag => tag.includes('custom_'));
            customTags = customTags.map(tag => tag.split('_').pop().toUpperCase());
            
            let saveUp = 0;
let maxPriceDiff = 0;

const customOriginalRaw = li.getAttribute('data-custom-original-price');
const customDiscountRaw = li.getAttribute('data-custom-discount-price');

if (customOriginalRaw && customDiscountRaw) {
  const originalCents = Math.round(parseFloat(customOriginalRaw) * 100);
  const discountCents = Math.round(parseFloat(customDiscountRaw) * 100);

  if (
    Number.isFinite(originalCents) &&
    Number.isFinite(discountCents) &&
    originalCents > discountCents
  ) {
    const diffCents = originalCents - discountCents;
    maxPriceDiff = diffCents;
    saveUp = (diffCents / 100).toFixed(2);
  }
}



          if(isBestSeller === "true"){
            li.innerHTML = `
                <a href="${productURL}" style="border-bottom: none; display: block; text-decoration: none; color: black; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                    <div style="position: relative;">
                        <div style="display: flex; flex-wrap: wrap; gap: 0.5rem; align-items: center; width: 100%;">
                            ${maxPriceDiff > 0 ? `<p style='width: fit-content; font-size: 10px; background-color: #c12f28; padding: 0.4rem 0.8rem; margin: 0; border-radius: 8px; color: #fff; line-height: 1.2rem;'>SAVE $${saveUp}</p>` : ''}
                            ${customTags.map(tag => `<p style='width: fit-content; font-size: 10px; background-color: #E28B2B; padding: 0.4rem 0.8rem; margin: 0; border-radius: 8px; color: #fff; line-height: 1.2rem;'>${tag}</p>`).join('')}
                            <p style='width: fit-content; font-size: 10px; background-color: #E28B2B; padding: 0.4rem 0.8rem; margin: 0; border-radius: 8px; color: #fff; line-height: 1.2rem;'>BESTSELLER</p>
                        </div>
                        <img src="${media}" alt="${title}" width="75" style="width: 100%; aspect-ratio: 1; object-fit: cover; border-radius: 20px;">
                    </div>
                    <p class="primary-font" style="font-size: 14px; text-align: center; margin: 0;">${title}</p>
                </a>
            `;
          } 
          else if(isNew === "true") {
            li.innerHTML = `
                <a href="${productURL}" style="border-bottom: none; display: block; text-decoration: none; color: black; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                    <div style="position: relative;">
                        <div style="display: flex; flex-wrap: wrap; gap: 0.5rem; align-items: center; width: 100%;">
                            ${maxPriceDiff > 0 ? `<p style='width: fit-content; font-size: 10px; background-color: #c12f28; padding: 0.4rem 0.8rem; margin: 0; border-radius: 8px; color: #fff; line-height: 1.2rem;'>SAVE $${saveUp}</p>` : ''}
                            ${customTags.map(tag => `<p style='width: fit-content; font-size: 10px; background-color: #E28B2B; padding: 0.4rem 0.8rem; margin: 0; border-radius: 8px; color: #fff; line-height: 1.2rem;'>${tag}</p>`).join('')}
                            <p style='width: fit-content; font-size: 10px; background-color: #E28B2B; padding: 0.4rem 0.8rem; margin: 0; border-radius: 8px; color: #fff; line-height: 1.2rem;'>NEW</p>

                        </div>
                        <img src="${media}" alt="${title}" width="75" style="width: 100%; aspect-ratio: 1; object-fit: cover; border-radius: 20px;">
                    </div>
                    <p class="primary-font" style="font-size: 14px; text-align: center; margin: 0;">${title}</p>
                </a>
            `;
          }
          else {
            li.innerHTML = `
                <a href="${productURL}" style="border-bottom: none; display: block; text-decoration: none; color: black; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                    <div style="position: relative;">
                        <div style="display: flex; flex-wrap: wrap; gap: 0.5rem; align-items: center; width: 100%;">
                            ${maxPriceDiff > 0 ? `<p style='width: fit-content; font-size: 10px; background-color: #c12f28; padding: 0.4rem 0.8rem; margin: 0; border-radius: 8px; color: #fff; line-height: 1.2rem;'>SAVE $${saveUp}</p>` : ''}
                            ${customTags.map(tag => `<p style='width: fit-content; font-size: 10px; background-color: #E28B2B; padding: 0.4rem 0.8rem; margin: 0; border-radius: 8px; color: #fff; line-height: 1.2rem;'>${tag}</p>`).join('')}
                        </div>
                        <img src="${media}" alt="${title}" width="75" style="width: 100%; aspect-ratio: 1; object-fit: cover; border-radius: 20px;">
                    </div>
                    <p class="primary-font" style="font-size: 14px; text-align: center; margin: 0;">${title}</p>
                </a>
            `;
          }
            
            
        });
    }

    function loadCollectionCards() {
        const detailElements = document.querySelectorAll('details[data-url]')

        
        detailElements.forEach(async (detail) => {
            const span = detail.querySelector('.menu-drawer-summary__menu-item > span div')
            const collectionURL = detail.getAttribute('data-url')
        
            const response = await fetch(`${collectionURL}.json`)
            const data = await response.json()
            const { title, image, handle } = data.collection;
            
            if (image === null) {
                span.innerHTML = `
                    <div style="display: block; width: 55px; height: 55px; aspect-ratio: 1; object-fit: cover; border-radius: 10px; background-color: #fff;"></div>
                    <a href='/collections/${handle}' style="text-decoration: none; color: #000; primary-font" style="font-size: 19px; margin: 0;">${title}</a>
                `
            } else {
                // <img src="${image.src}" alt="${title}" width="55" height="55" style="aspect-ratio: 1; object-fit: cover; border-radius: 10px;">
                span.innerHTML = `
                    <a href='/collections/${handle}' style="text-decoration: none; color: #000; primary-font" style="font-size: 19px; margin: 0;">${title}</a>
                `
            }
            
            // const summary = detail.querySelector('summary')
            // summary.ariaExpanded = false;

            // summary.addEventListener('click', (e) => {
            //     e.target.ariaExpanded = !e.target.ariaExpanded
            // })
        })
    }

    loadProductCards();
    loadCollectionCards();
}

loadDrawerDesign()
